import { Category } from "../types/ingredient";
import { images } from "./images";

export const categories: Category[] = [
  {
    id: "huiles-essentielles",
    name: "Huiles essentielles",
    count: 28,
    description:
      "Distillées à la vapeur d'eau dans les 24 h suivant la récolte. Profils chromatographiques fournis pour chaque lot.",
    image: images.still,
    caption: "Alambic cuivre, distillerie du domaine",
  },
  {
    id: "hydrolats",
    name: "Hydrolats",
    count: 14,
    description:
      "Eaux florales issues de nos distillations, stabilisées sans conservateur ou selon votre cahier des charges.",
    image: images.lab,
    caption: "Hydrolat de lavande fine, lot 2026-07",
  },
  {
    id: "huiles-vegetales",
    name: "Huiles végétales",
    count: 11,
    description:
      "Première pression à froid, olive, amande et chanvre de producteurs partenaires provençaux.",
    image: images.botanicals,
    caption: "Matières premières de la saison",
  },
  {
    id: "macerats",
    name: "Macérats huileux",
    count: 9,
    description:
      "Fleurs séchées au domaine puis macérées lentement : calendula, millepertuis, arnica, immortelle.",
    image: images.harvest,
    caption: "Récolte manuelle, coteaux du Luberon",
  },
  {
    id: "extraits-co2",
    name: "Extraits CO₂",
    count: 7,
    description:
      "Extraction supercritique sans solvant résiduel. Actifs antioxydants et fractions aromatiques concentrées.",
    image: images.lab,
    caption: "Laboratoire de contrôle qualité",
  },
  {
    id: "poudres",
    name: "Poudres & cires",
    count: 12,
    description:
      "Feuilles et fleurs micronisées, argiles et cires végétales pour soins solides et masques.",
    image: images.botanicals,
    caption: "Plantes séchées à basse température",
  },
];
